var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isModalOpen
    ? _c(
        "div",
        {
          staticClass: "modal fade in modal-open",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.stopPropagation()
              return _vm.closeModal($event)
            }
          }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal__header modal__header--rm-bg",
                  class: _vm.headerClass
                },
                [
                  _c("div", { staticClass: "modal__header--angles" }, [
                    _c("img", {
                      staticClass: "modal__profile-pic",
                      attrs: { src: _vm.rm.headshot }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__contact-name" }, [
                      _vm._v(_vm._s(_vm.rm.fullName))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__contact-position" }, [
                      _vm._v(_vm._s(_vm.rm.position))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__contact-row" }, [
                      _c("div", { staticClass: "modal__contact-phone" }, [
                        _vm._v(_vm._s(_vm.rm.phone))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal__contact-separator" }, [
                        _vm._v("|")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal__contact-email" }, [
                        _vm._v(_vm._s(_vm.rm.email))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__close-btn" }, [
                      _c("i", {
                        staticClass: "fa fa-times",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.closeModal($event)
                          }
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal__body" }, [
                _c(
                  "div",
                  {
                    staticClass: "container-fluid",
                    attrs: { slot: "modal-body" },
                    slot: "modal-body"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "modal__contact-row modal__contact-row--doc"
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "modal__contact-msg-box--title" },
                          [_vm._v(_vm._s(_vm.modalData.title))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.fuelEmployee
                      ? _c(
                          "div",
                          {
                            staticClass: "modal__form-placeholder",
                            on: { click: _vm.closeModal }
                          },
                          [_vm._v("Only members can send messages to RMs.")]
                        )
                      : _c(
                          "form",
                          {
                            attrs: {
                              name: "getCourseInfo",
                              id: "getCourseInfo"
                            }
                          },
                          [
                            _c("div", { staticClass: "modal__contact-row" }, [
                              _c("div", { staticClass: "col-sm-12" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.text,
                                      expression: "text"
                                    }
                                  ],
                                  staticClass:
                                    "modal__comment-block modal__comment-block--vendor",
                                  attrs: {
                                    name: "message",
                                    placeholder: "Enter message"
                                  },
                                  domProps: { value: _vm.text },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.text = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ])
                          ]
                        )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer" }, [
                _vm.isSending
                  ? _c(
                      "div",
                      { staticClass: "modal__sending-overlay" },
                      [
                        _c("moon-loader", {
                          attrs: { size: "25px", color: "#1176BB" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "modal__send-btn",
                        on: {
                          click: function($event) {
                            return _vm.sendMessage()
                          }
                        }
                      },
                      [_vm._v("Send")]
                    )
              ])
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }